<template>
  <div v-if="$store.getters['authorization/acl'].hasPermission('surveys_access')"
       class="PlatformSurveysView">
    <ShPageHeader :title="'Ankiety'"
                  description="Poniżej znajdują się szczegółowe informacje dotyczące ankiet."
                  :breadcrumb-items="[
                    { label: 'zarządzanie' },
                    { label: 'Ankiety', path: '/surveys' }
                  ]" />
    <ShPageLayout>
      <CustomTabs active-tab="survey_results"
                  :tabs="[
                    { name: 'survey_results', label: 'Wyniki ankiet', isVisible: $store.getters['authorization/acl'].hasPermission('allow_survey_results') },
                    { name: 'survey_creator', label: 'Tworzenie ankiet', isVisible: $store.getters['authorization/acl'].hasPermission('allow_survey_edit') },
                    { name: 'survey_charts', label: 'Analiza', isVisible: $store.getters['authorization/acl'].hasPermission('survey_charts_access') }
                  ]">
        <template #survey_creator>
          <SurveyCreator :projects-list="projectsList" />
        </template>
        <template #survey_results>
          <SurveyResults :projects-list="projectsList" />
        </template>
        <template #survey_charts>
          <SurveyCharts />
        </template>
      </CustomTabs>
    </ShPageLayout>
  </div>
</template>

<script>

import { customValidations } from '@/mixins';
import CustomTabs from '../components/Common/CustomTabs';
import SurveyCreator from '../components/Surveys/SurveyCreator';
import SurveyResults from '../components/Surveys/SurveyResults';
import SurveyCharts from '../components/Surveys/SurveyCharts';



export default {
  name: 'PlatformSurveys',
  components: {
    CustomTabs,
    SurveyCreator,
    SurveyResults,
    SurveyCharts
  },

  mixins: [customValidations],

  data() {
    return {
    };
  },

  computed: {
    projectsList() {
      return this.$store.getters['client/projects/list'].records;
    },
    userData() {
      return this.$store.getters['authorization/user'];
    },
    projectsUuids() {
      const projects = this.$store.getters['client/projects/list']?.records;
      const projectsUuids = projects.map(project => project.uuid);
      return projectsUuids;
    },
  },

  methods: {
  },

  async created() {
    await this.$store.dispatch('client/projects/getList', this.userData.client.client_uuid);
    await this.$store.dispatch('campaigns/getList');
    await this.$store.dispatch('campaign/getSurveyInputTypesList');
  },
};
</script>

<style lang="sass" scoped>
.PlatformSurveysView
</style>